import React, { useEffect } from "react";
import { connect } from "react-redux";
import RenderTable from "components/table";
import { bindActionCreators } from "redux";
import { Creators as TagsActions } from "store/readers-tags/tags/tags-duck";
import { IItems } from "store/readers-tags/tags/tags-model";
import ColumnsTable from "./columnsTable";
import * as S from "./index.styled";

interface IPropsScreenTagsGrid {
  pageIndex?: number;
  items?: Array<IItems>;
  totalItems?: number;
  searchFilter?: string;
  isLoadingTable: boolean;
}
interface IDispatchProps {
  tagsChangeFieldValue?: (...args) => void;
  tagsFetchByIdAsync: (...args) => void;
  tagsRegisterFetchAsync?: (...args) => void;
  tagsShowDrawer?: (...args) => void;
}

type IProps = IPropsScreenTagsGrid & IDispatchProps;

const TagsGrid = ({ items, totalItems, searchFilter, pageIndex, isLoadingTable, tagsRegisterFetchAsync, tagsChangeFieldValue, tagsFetchByIdAsync, tagsShowDrawer }: IProps) => {
  useEffect(() => {
    tagsRegisterFetchAsync();
  }, [tagsRegisterFetchAsync]);

  useEffect(() => {
    if (searchFilter !== "" || searchFilter === null) {
      tagsChangeFieldValue("pageIndex", 1);
      tagsRegisterFetchAsync();
    }
  }, [searchFilter]);

  const handleTableChange = (pagination) => {
    tagsChangeFieldValue("itemsByPage", pagination.pageSize);
    tagsChangeFieldValue("pageIndex", pagination.current);
    tagsRegisterFetchAsync();
  };

  const handleClick = (data) => {
    tagsFetchByIdAsync(data.id);
    tagsShowDrawer();
  };

  return (
    <S.TagsContainer>
      <RenderTable
        columnsTable={ColumnsTable({ handleClick })}
        items={items}
        totalItems={totalItems}
        handleTableChange={handleTableChange}
        pageIndex={pageIndex}
        isLoadingTable={isLoadingTable}
      />
    </S.TagsContainer>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...TagsActions }, dispatch);

const mapStateToProps = (state) => ({
  isLoadingTable: state.Tags.isLoadingTable,
  itemsByPage: state.Tags.filter.itemsByPage,
  pageIndex: state.Tags.filter.pageIndex,
  items: state.Tags.items,
  totalItems: state.Tags.totalItems,
  searchFilter: state.Tags.searchFilter,
});

export default connect(mapStateToProps, mapDispatchToActions)(TagsGrid);
